import { HttpService, createHttpService } from '@/services/HttpService';
import { Pricing, PricingMode } from '@/app/domain/Pricing';

enum ServerPricingMode {
  Trial = 'trial',
  Production = 'production',
  Suspended = 'suspended'
}
type ServerPricing = {
  mode: ServerPricingMode;
};

export class PricingService {
  constructor(
    private tenantUuid: string,
    private httpService: HttpService
  ) {

  }

  public async getPricing(): Promise<Pricing | null> {
    try {
      const serverPricing: ServerPricing = await this.httpService.get<void, ServerPricing>(
        `/api/2/tenants/${this.tenantUuid}/pricing`
      );
      return this.convertServerPricingToPricing(serverPricing);
    } catch (error) {
      return null;
    }
  }

  private convertServerPricingToPricing(serverPricing: ServerPricing): Pricing {
    return { mode: this.convertServerPricingModeToPricingMode(serverPricing.mode) };
  }

  private convertServerPricingModeToPricingMode(serverPricingMode: ServerPricingMode): PricingMode {
    return {
      [ServerPricingMode.Trial]: PricingMode.Trial,
      [ServerPricingMode.Production]: PricingMode.Production,
      [ServerPricingMode.Suspended]: PricingMode.Suspended
    }[serverPricingMode];
  }
}

export function createPricingService(selfTenantUuid: string, tenantUuid: string): PricingService {
  const httpService: HttpService = createHttpService(selfTenantUuid);

  return new PricingService(tenantUuid, httpService);
}
